'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataCertificateOfOriginForm(number, recipient, originOfGoods, documentaryCredit, placeOfReceipt, placeOfLoading, placeOfDelivery, placeOfDischarge, invoiceNumber, currency, goods, incoterm, shippingMarks, consignee, invoiceDate, purchaseOrderContract, hsCode, issueDate, shipper, manufacturer, vesselOrFlightNumber, voyage, preCarriageVesselOrFlightNumber, sealNumber, containerNumber, shipmentDate, truckNumber, documentNote) {
  this.dX = null;
  this.e5 = null;
  this.dY = null;
  this.dR = null;
  this.e2 = null;
  this.e1 = null;
  this.dZ = null;
  this.e0 = null;
  this.dV = null;
  this.dJ = null;
  this.dS = null;
  this.dU = null;
  this.e8 = null;
  this.dO = null;
  this.dK = null;
  this.e4 = null;
  this.dT = null;
  this.dL = null;
  this.e7 = null;
  this.dW = null;
  this.ea = null;
  this.eb = null;
  this.e3 = null;
  this.e6 = null;
  this.dP = null;
  this.dM = null;
  this.e9 = null;
  this.dQ = null;
  this.dX = number;
  this.e5 = recipient;
  this.dY = originOfGoods;
  this.dR = documentaryCredit;
  this.e2 = placeOfReceipt;
  this.e1 = placeOfLoading;
  this.dZ = placeOfDelivery;
  this.e0 = placeOfDischarge;
  this.dV = invoiceNumber;
  this.dJ = currency;
  this.dS = goods;
  this.dU = incoterm;
  this.e8 = shippingMarks;
  this.dO = consignee;
  this.dK = invoiceDate;
  this.e4 = purchaseOrderContract;
  this.dT = hsCode;
  this.dL = issueDate;
  this.e7 = shipper;
  this.dW = manufacturer;
  this.ea = vesselOrFlightNumber;
  this.eb = voyage;
  this.e3 = preCarriageVesselOrFlightNumber;
  this.e6 = sealNumber;
  this.dP = containerNumber;
  this.dM = shipmentDate;
  this.e9 = truckNumber;
  this.dQ = documentNote;
}
export { $c_Lapp_data_AppDocumentDataCertificateOfOriginForm as $c_Lapp_data_AppDocumentDataCertificateOfOriginForm };
$p = $c_Lapp_data_AppDocumentDataCertificateOfOriginForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataCertificateOfOriginForm;
/** @constructor */
function $h_Lapp_data_AppDocumentDataCertificateOfOriginForm() {
}
export { $h_Lapp_data_AppDocumentDataCertificateOfOriginForm as $h_Lapp_data_AppDocumentDataCertificateOfOriginForm };
$h_Lapp_data_AppDocumentDataCertificateOfOriginForm.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentDataCertificateOfOriginForm)) {
    if ((this.dX === x$0.dX)) {
      var x = this.e5;
      var x$2 = x$0.e5;
      var $x_24 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_24 = false;
    }
    if (($x_24 && (this.dY === x$0.dY))) {
      var x$3 = this.dR;
      var x$4 = x$0.dR;
      var $x_23 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_23 = false;
    }
    if ($x_23) {
      var x$5 = this.e2;
      var x$6 = x$0.e2;
      var $x_22 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_22 = false;
    }
    if ($x_22) {
      var x$7 = this.e1;
      var x$8 = x$0.e1;
      var $x_21 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_21 = false;
    }
    if ($x_21) {
      var x$9 = this.dZ;
      var x$10 = x$0.dZ;
      var $x_20 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_20 = false;
    }
    if ($x_20) {
      var x$11 = this.e0;
      var x$12 = x$0.e0;
      var $x_19 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_19 = false;
    }
    if (($x_19 && (this.dV === x$0.dV))) {
      var x$13 = this.dJ;
      var x$14 = x$0.dJ;
      var $x_18 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_18 = false;
    }
    if ($x_18) {
      var x$15 = this.dS;
      var x$16 = x$0.dS;
      var $x_17 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_17 = false;
    }
    if ($x_17) {
      var x$17 = this.dU;
      var x$18 = x$0.dU;
      var $x_16 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_16 = false;
    }
    if ($x_16) {
      var x$19 = this.e8;
      var x$20 = x$0.e8;
      var $x_15 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$21 = this.dO;
      var x$22 = x$0.dO;
      var $x_14 = ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$23 = this.dK;
      var x$24 = x$0.dK;
      var $x_13 = ((x$23 === null) ? (x$24 === null) : x$23.f(x$24));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$25 = this.e4;
      var x$26 = x$0.e4;
      var $x_12 = ((x$25 === null) ? (x$26 === null) : x$25.f(x$26));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$27 = this.dT;
      var x$28 = x$0.dT;
      var $x_11 = ((x$27 === null) ? (x$28 === null) : x$27.f(x$28));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$29 = this.dL;
      var x$30 = x$0.dL;
      var $x_10 = ((x$29 === null) ? (x$30 === null) : x$29.f(x$30));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$31 = this.e7;
      var x$32 = x$0.e7;
      var $x_9 = ((x$31 === null) ? (x$32 === null) : x$31.f(x$32));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$33 = this.dW;
      var x$34 = x$0.dW;
      var $x_8 = ((x$33 === null) ? (x$34 === null) : x$33.f(x$34));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$35 = this.ea;
      var x$36 = x$0.ea;
      var $x_7 = ((x$35 === null) ? (x$36 === null) : x$35.f(x$36));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$37 = this.eb;
      var x$38 = x$0.eb;
      var $x_6 = ((x$37 === null) ? (x$38 === null) : x$37.f(x$38));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$39 = this.e3;
      var x$40 = x$0.e3;
      var $x_5 = ((x$39 === null) ? (x$40 === null) : x$39.f(x$40));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$41 = this.e6;
      var x$42 = x$0.e6;
      var $x_4 = ((x$41 === null) ? (x$42 === null) : x$41.f(x$42));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$43 = this.dP;
      var x$44 = x$0.dP;
      var $x_3 = ((x$43 === null) ? (x$44 === null) : x$43.f(x$44));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$45 = this.dM;
      var x$46 = x$0.dM;
      var $x_2 = ((x$45 === null) ? (x$46 === null) : x$45.f(x$46));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$47 = this.e9;
      var x$48 = x$0.e9;
      var $x_1 = ((x$47 === null) ? (x$48 === null) : x$47.f(x$48));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$49 = this.dQ;
      var x$50 = x$0.dQ;
      return ((x$49 === null) ? (x$50 === null) : x$49.f(x$50));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 28;
});
$p.t = (function() {
  return "AppDocumentDataCertificateOfOriginForm";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.dX;
      break;
    }
    case 1: {
      return this.e5;
      break;
    }
    case 2: {
      return this.dY;
      break;
    }
    case 3: {
      return this.dR;
      break;
    }
    case 4: {
      return this.e2;
      break;
    }
    case 5: {
      return this.e1;
      break;
    }
    case 6: {
      return this.dZ;
      break;
    }
    case 7: {
      return this.e0;
      break;
    }
    case 8: {
      return this.dV;
      break;
    }
    case 9: {
      return this.dJ;
      break;
    }
    case 10: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(this.dS);
      break;
    }
    case 11: {
      return this.dU;
      break;
    }
    case 12: {
      return this.e8;
      break;
    }
    case 13: {
      return this.dO;
      break;
    }
    case 14: {
      return this.dK;
      break;
    }
    case 15: {
      return this.e4;
      break;
    }
    case 16: {
      return this.dT;
      break;
    }
    case 17: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(this.dL);
      break;
    }
    case 18: {
      return this.e7;
      break;
    }
    case 19: {
      return this.dW;
      break;
    }
    case 20: {
      return this.ea;
      break;
    }
    case 21: {
      return this.eb;
      break;
    }
    case 22: {
      return this.e3;
      break;
    }
    case 23: {
      return this.e6;
      break;
    }
    case 24: {
      return this.dP;
      break;
    }
    case 25: {
      return this.dM;
      break;
    }
    case 26: {
      return this.e9;
      break;
    }
    case 27: {
      return this.dQ;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "number";
      break;
    }
    case 1: {
      return "recipient";
      break;
    }
    case 2: {
      return "originOfGoods";
      break;
    }
    case 3: {
      return "documentaryCredit";
      break;
    }
    case 4: {
      return "placeOfReceipt";
      break;
    }
    case 5: {
      return "placeOfLoading";
      break;
    }
    case 6: {
      return "placeOfDelivery";
      break;
    }
    case 7: {
      return "placeOfDischarge";
      break;
    }
    case 8: {
      return "invoiceNumber";
      break;
    }
    case 9: {
      return "currency";
      break;
    }
    case 10: {
      return "goods";
      break;
    }
    case 11: {
      return "incoterm";
      break;
    }
    case 12: {
      return "shippingMarks";
      break;
    }
    case 13: {
      return "consignee";
      break;
    }
    case 14: {
      return "invoiceDate";
      break;
    }
    case 15: {
      return "purchaseOrderContract";
      break;
    }
    case 16: {
      return "hsCode";
      break;
    }
    case 17: {
      return "issueDate";
      break;
    }
    case 18: {
      return "shipper";
      break;
    }
    case 19: {
      return "manufacturer";
      break;
    }
    case 20: {
      return "vesselOrFlightNumber";
      break;
    }
    case 21: {
      return "voyage";
      break;
    }
    case 22: {
      return "preCarriageVesselOrFlightNumber";
      break;
    }
    case 23: {
      return "sealNumber";
      break;
    }
    case 24: {
      return "containerNumber";
      break;
    }
    case 25: {
      return "shipmentDate";
      break;
    }
    case 26: {
      return "truckNumber";
      break;
    }
    case 27: {
      return "documentNote";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_AppDocumentDataCertificateOfOriginForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iN)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataCertificateOfOriginForm as $isArrayOf_Lapp_data_AppDocumentDataCertificateOfOriginForm };
var $d_Lapp_data_AppDocumentDataCertificateOfOriginForm = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataCertificateOfOriginForm, "app.data.AppDocumentDataCertificateOfOriginForm", ({
  iN: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentDataCertificateOfOriginForm as $d_Lapp_data_AppDocumentDataCertificateOfOriginForm };
//# sourceMappingURL=app.data.-App-Document-Data-Certificate-Of-Origin-Form.js.map
